import styled from 'styled-components/macro'

const Container = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  max-height: 1080px;
`

export { Container }
